// extracted by mini-css-extract-plugin
export default {"root":"Loader_root__DKyB2"};